import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from '@/common/containers/TaskDetails/styles.less';

const TaskActions = ({
  isDeactivated,
  isReleaseMode,
  onHold,
  onDeactivate,
  onRelease,
  isHoldLoading,
  isDeactivateLoading,
  isReleaseLoading,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.infoBlock}>
      <div className={styles.infoBlockHeader}>
        <h5 className={styles.infoBlockHeaderTitle}>{t('Task Actions')}</h5>
        <Tooltip
          placement="left-start"
          slotProps={{
            tooltip: { className: styles.actionsTooltip },
          }}
          title={
            <>
              {(!isReleaseMode || !isDeactivated) && (
                <>
                  <b>{t('Put task on hold')}</b>
                  <p>{t('Put task on hold description')}</p>
                </>
              )}
              {(!isReleaseMode || isDeactivated) && (
                <>
                  <b>{t('Deactivate task')}</b>
                  <p>{t('Deactivate task description')}</p>
                </>
              )}
            </>
          }
        >
          <InfoIcon />
        </Tooltip>
      </div>
      <div className={cx(styles.infoBlockBody, styles.taskActions)}>
        {isReleaseMode ? (
          <Button
            variant="contained"
            color="success"
            onClick={onRelease}
            loading={isReleaseLoading}
          >
            {isDeactivated ? t('Reactivate task') : t('Release from hold')}
          </Button>
        ) : (
          <>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onHold}
              loading={isHoldLoading}
              disabled={isDeactivateLoading}
            >
              {t('Put on hold')}
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={onDeactivate}
              loading={isDeactivateLoading}
              disabled={isHoldLoading}
            >
              {t('Deactivate')}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default TaskActions;
